var render, staticRenderFns
import script from "./CarbonAds.vue?vue&type=script&lang=js"
export * from "./CarbonAds.vue?vue&type=script&lang=js"
import style0 from "./CarbonAds.vue?vue&type=style&index=0&id=a4d13a10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports